import React from "react";

export default function Form ({ children, id }) {

    return (
        <form className="form" id={id}>
            {children}
        </form>
    )
}